import { useEffect, useState } from "react";

export const usePlatform = () => {
  const [platform, setPlatform] = useState<"android" | "ios" | "unknown">(
    "unknown"
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    if (window.gateio && typeof window.gateio.gatepay === "function") {
      setPlatform("android");
    } else if (window.webkit?.messageHandlers?.gatepay) {
      setPlatform("ios");
    } else {
      setPlatform("unknown");
    }
  }, []);

  return platform;
};
